<template>
  <div>
    <div :style="(minimized && canExpand()) ? styleObject : ''">
      <div :class="{'minimized': minimized && canExpand()}" :style="styleObject">
        <div v-html="decodedHtml" ref="siteDescription"></div>
      </div>
      <div class="fadeout" v-if="minimized && canExpand()"></div>
    </div>
    <a href="" v-if="canExpand()" @click.prevent="minimized = !minimized">
      {{minimized ? 'Show More' : 'Show Less'}}
    </a>
  </div>
</template>

<script>
var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {
      minimized: true,
      isMounted: false
    };
  },

  props: {
    text: {
      required: true,
      type: String
    },

    maxHeight: {
      required: false,
      type: Number,
      default: 100
    }
  },

  computed: {
    decodedHtml: function() {
      if (this.text) {
        return htmlDecode(this.text);
      }
      return "";
    },

    styleObject: function() {
      if (this.minimized) {
        return {
          maxHeight: this.maxHeight + "px"
        };
      }
      return {};
    }
  },

  methods: {
    canExpand: function() {
      if (this.isMounted) {
        return this.$refs.siteDescription.clientHeight > this.maxHeight;
      }
      return false;
    }
  },

  mounted() {
    this.isMounted = true;
  }
};
</script>

<style scoped>
.minimized {
  overflow: hidden;
}

.fadeout {
  position: relative;
  bottom: 100px;
  height: 100px;
  background: -webkit-linear-gradient(
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  background-image: -moz-linear-gradient(
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  background-image: -o-linear-gradient(
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  background-image: linear-gradient(
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  background-image: -ms-linear-gradient(
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  );
}

.align-center {
  text-align: center;
}
</style>
